export default __webpack_public_path__ + "static/media/445.9569e2fc.jpg";